import { connect } from 'react-redux';
import { editComment, copyComment, getAddressByLatLong } from '../../actions/GlobalsActions';
import { uninstallPressureSensor, updatePressureSensor } from '../../actions/SensorsActions';
import PressureSensorDetailsTab from '../../components/SensorsTabs/PressureSensorDetailsTab/PressureSensorDetailsTab';

const diff = require('deep-diff').diff;

const mapStateToProps = (state, ownProps) => {
  const { selectedProject, user } = state.leaksList;
  const selectedFeature = state.leaksList.leaksByProject.selectedFeature;

  if (selectedProject) {
    const leaks = state.leaksList.leaksByProject[selectedProject];
    if (leaks && selectedFeature && leaks.sensors && leaks.sensors.pressureSensors) {
      const pressureSensors = leaks.sensors.pressureSensors;
      const sensor = pressureSensors.items[pressureSensors.indexMap[selectedFeature]];

      return Object.assign({}, {
        user,
        selectedFeature,
        selectedProject,
        timeZone: state.local.timeZone,
        initialValues: sensor,
        sensorData: sensor,
      }, ownProps);
    }
  }

  return { user };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: (values, dispatch, props) => {
      const differences = diff(values, props.initialValues);
      if (!differences) return;

      const data = [];
      differences.forEach((d) => {
        data.push({
          field: d.path[0],
          value: d.lhs,
        });
      });

      dispatch(updatePressureSensor(props.selectedProject, props.selectedFeature, data));
    },
    onEdit: () => {
      dispatch(editComment('pressureSensorDetails', 'Comment'));
    },
    onCopy: () => {
      dispatch(copyComment('pressureSensorDetails', 'Comment'));
    },
    getAddressByLatLong: () => {
      dispatch(getAddressByLatLong('pressureSensorDetails', 'Address'));
    },
    dispatchUninstall: (selectedProject, sensorId, onResult) => {
      dispatch(uninstallPressureSensor(selectedProject, sensorId, (result) => {
        if (onResult && result) {
          onResult(result);
        }
      }));
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onUninstall: (sensorId, onResult) => {
      dispatchProps.dispatchUninstall(stateProps.selectedProject, sensorId, onResult);
    },
  };
};

const CPressureSensorDetailsTab = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PressureSensorDetailsTab);

export default CPressureSensorDetailsTab;
